import {PolyDictionary} from '../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {CodeExporterDispatcher} from './Dispatcher';

interface CodeOptions {
	nodesMapVarName: string;
}
export type NodesByRequestedName = PolyDictionary<BaseNodeType>;

export interface NodesCodeExporterOption {
	ignoreGrandChildren?: boolean;
	replaceTypeWith?: string;
}
export class NodesCodeExporter {
	_lines: string[] = [];
	constructor(private _nodes: BaseNodeType[], protected options: NodesCodeExporterOption = {}) {}

	process(parent_var_name?: string, position_x_offset?: number) {
		this._lines = [];

		this.add_process(parent_var_name, position_x_offset);

		return this._lines;
	}

	process_with_existing_nodes(parent: BaseNodeType, parent_var_name: string, position_x_offset?: number) {
		this._lines = [];

		const nodesMapVarName = `nodesByRequestedName_${parent.graphNodeId()}`;

		this._lines.push(`var ${nodesMapVarName} = {}`);
		this.add_existing_nodes(parent, parent_var_name);
		this.add_process(parent_var_name, position_x_offset, {nodesMapVarName});
		this._lines.push(`return ${nodesMapVarName}`);

		return this._lines;
	}

	private add_process(parent_var_name?: string, position_x_offset?: number, options?: CodeOptions) {
		if (parent_var_name) {
			this.multi_push(this.create_function_declare(parent_var_name));
			this.multi_push(this.create_function_call(parent_var_name, options));
		}

		for (let node of this._nodes) {
			this.multi_push(
				CodeExporterDispatcher.dispatch_node(node, this.options).set_up({position_x_offset: position_x_offset})
			);
		}
	}

	private add_existing_nodes(parent: BaseNodeType, parent_var_name: string) {
		parent.children().forEach((child) => {
			const child_var_name = CodeExporterDispatcher.dispatch_node(child, this.options).var_name();
			const line = `var ${child_var_name} = ${parent_var_name}.node('${child.name()}')`;

			this._lines.push(line);
		});
	}

	create_function_declare(parent_var_name: string): string[] {
		const lines: string[] = [];
		for (let node of this._nodes) {
			const child_lines = CodeExporterDispatcher.dispatch_node(node, this.options).create_function_declare(
				parent_var_name
			);
			child_lines.forEach((child_line) => {
				lines.push(child_line);
			});
		}
		return lines;
	}
	create_function_call(parent_var_name: string, options?: CodeOptions): string[] {
		const lines: string[] = [];
		for (let node of this._nodes) {
			const nodeExporter = CodeExporterDispatcher.dispatch_node(node, this.options);
			const child_line = nodeExporter.create_function_call(parent_var_name);
			lines.push(child_line);
			const nodesMapVarName = options?.nodesMapVarName;
			if (nodesMapVarName) {
				lines.push(`${nodesMapVarName}['${nodeExporter.var_name()}'] = ${nodeExporter.var_name()}`);
			}
		}
		return lines;
	}

	private multi_push(child_lines: string[]) {
		child_lines.forEach((child_line) => {
			this._lines.push(child_line);
		});
	}
}
